import * as echarts from 'echarts';
let animationDuration = 2000;

function getColor(color1, color2) {
	return new echarts.graphic.LinearGradient(
		0, 0, 0, 1, // 从上到下渐变
		[{
			offset: 0,
			color: color1
		}, {
			offset: 1,
			color: color2
		}]
	)
}

function setData(data, name = undefined, color = getColor('#00ffea', '#3ac1ff'), barWidth = '5%') {
	return {
		name,
		data,
		type: 'bar',
		barWidth, // 设置柱子宽度（也可以是具体像素：'30'）
		itemStyle: {
			color
		},
		label: {
			color: '#FFF'
		},
	}
}

function setZData(data, color, name = undefined) {
	return {
		name,
		type: 'line',
		data,
		symbol: 'circle',
		symbolSize: 8,
		lineStyle: {
			width: 2,
			color
		},
		itemStyle: {
			color
		},
		areaStyle: {
			color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
					offset: 0,
					color: color
				}, // 顶部：线条颜色
				{
					offset: 1,
					color: 'rgba(0,0,0,0)'
				} // 底部：透明
			])
		}
	}
}


function getGasList(listNum = 8, fixed = 2) {
	let val = [];
	for (let i = 0; i < listNum; i++) {
		val.push(Number((Math.random() * 150 + 50).toFixed(fixed)))
	}
	return val
}
let mouths = []
for (let i = 1; i < 13; i++) {
	mouths.push(i + '月')
}
// 公共用电
export const electricityOption = {
	animationDuration, 
	xAxis: {
		type: 'category',
		data: mouths,
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	legend: {
		right: 10,
		top: 10,
		symbol: 'circle', // 设置为圆形
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 10
		}
	},
	grid: {
		top: 68,
		left: 50,
		right: 20,
		bottom: 20,
	},
	tooltip: {
		trigger: 'axis'
	},
	yAxis: {
		type: 'value',
		splitNumber: 2,
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	series: [
		setZData(getGasList(6), '#fff336', '2025年总用电量'),
		setZData(getGasList(12), '#fd7b39', '2024年总用电量')
	]
};

// 公共用电
export const electricityOption2 = {
	animationDuration, 
	xAxis: {
		type: 'category',
		data: mouths,
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	legend: {
		right: 10,
		top: 10,
		symbol: 'circle', // 设置为圆形
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 10
		}
	},
	grid: {
		top: 68,
		left: 50,
		right: 20,
		bottom: 20,
	},
	tooltip: {
		trigger: 'axis'
	},
	yAxis: {
		type: 'value',
		splitNumber: 2,
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	series: [
		setZData(getGasList(6), '#fff336', '2025年总用水量'),
		setZData(getGasList(12), '#fd7b39', '2024年总用水量')
	]
};


// {
// 	animationDuration, 
// 	tooltip: {
// 		trigger: 'item'
// 	},
// 	legend: {
// 		type: 'scroll',
// 		orient: 'vertical',
// 		symbol: 'circle',
// 		left: 10,
// 		top: 60,
// 		itemGap: 10,
// 		itemWidth: 4,
// 		itemHeight: 4,
// 		symbol: 'circle', // 设置为圆形
// 		symbolSize: [12, 12], // 设置图例圆形的大小
// 		textStyle: {
// 			color: '#FFF'
// 		}
// 	},
// 	series: [{
// 		name: '用电分析（kw · h）',
// 		type: 'pie',
// 		radius: ['42%', '90%'],
// 		avoidLabelOverlap: false,
// 		label: {
// 			show: false,
// 			position: 'center'
// 		},
// 		top: 60,
// 		left: 100,
// 		itemStyle: {
// 			borderRadius: 0,
// 			borderColor: 'rgba(0,0,0,0)',
// 			borderWidth: 6
// 		},
// 		// roseType: 'radius',
// 		emphasis: {
// 			label: {
// 				show: true,
// 				fontSize: 40,
// 				fontWeight: 'bold'
// 			}
// 		},
// 		labelLine: {
// 			show: false
// 		},
// 		data: [{
// 				value: 748,
// 				name: '楼内公共',
// 				itemStyle: {
// 					color: getColor('#f46566', '#f46566')
// 				},
// 			},
// 			{
// 				value: 935,
// 				name: '园区',
// 				itemStyle: {
// 					color: getColor('#3ed4eb', '#3ed4eb')
// 				},
// 			},
// 			{
// 				value: 1435,
// 				name: '地库',
// 				itemStyle: {
// 					color: getColor('#ff9830', '#ff9830')
// 				},
// 			},
// 			{
// 				value: 1935,
// 				name: '管理处',
// 				itemStyle: {
// 					color: getColor('#0667d4', '#0667d4')
// 				},
// 			},
// 			{
// 				value: 2205,
// 				name: '能源中心',
// 				itemStyle: {
// 					color: getColor('#5ade9d', '#5ade9d')
// 				},
// 			},
// 			{
// 				value: 2635,
// 				name: '充电桩',
// 				itemStyle: {
// 					color: getColor('#349cfe', '#349cfe')
// 				},
// 			}
// 		]
// 	}]
// };

// 客户用电
let userXlist = []
let userValList = []
let userValList2 = []
for (let i = 1; i <= 17; i++) {
	userXlist.push(`${i}栋`);
	userValList.push((50 + Math.random() * 150).toFixed(2));
	userValList2.push((50 + Math.random() * 150).toFixed(2));
}
export const userElectricityOption = {
	animationDuration, 
	xAxis: {
		type: 'category',
		data: userXlist,
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	grid: {
		top: 68,
		left: 60,
		right: 0,
		bottom: 30,
	},
	tooltip: {
		trigger: 'axis'
	},
	yAxis: {
		type: 'value',
		axisLabel: {
			fontSize: 10,
			color: '#05d0e6' // 红色字体
		},
		
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	series: [
		setData(getGasList(17), '2025年用电量 (kw)', getColor('#00C0FA', '#015EEA'), '26%'),
		setZData(getGasList(17), '#ff1a06', '2024年用电量 (kw)')
	],
};



export const userElectricityOption2 = {
	animationDuration, 
	xAxis: {
		type: 'category',
		data: ['7-2商铺', '7-5商铺'],
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	legend: {
		type: 'scroll',
		// orient: 'vertical',
		right: 10,
		top: 10,
		symbol: 'circle', // 设置为圆形
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 10
		}
	},
	grid: {
		top: 68,
		left: 60,
		right: 30,
		bottom: 30,
	},
	tooltip: {
		trigger: 'axis'
	},
	yAxis: {
		type: 'value',
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	series: [
		setData([136, 188], '5月用电', getColor('#ff1a06', '#cb1204'), '26%'),
		setData([46, 88], '6月用电', getColor('#00C0FA', '#015EEA'), '26%'),
	],
};
// 生活用水

export const publicWaterOption = {
	animationDuration, 
	xAxis: {
		type: 'category',
		data: mouths,
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	legend: {
		right: 10,
		top: 10,
		symbol: 'circle', // 设置为圆形
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 10
		}
	},
	grid: {
		top: 68,
		left: 50,
		right: 20,
		bottom: 20,
	},
	tooltip: {
		trigger: 'axis'
	},
	yAxis: {
		type: 'value',
		splitNumber: 2,
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	series: [
		setZData([120,128,120,0,0,0,0], '#fc5d39', '2025年天然气用量'),
		setZData([130,125,111,0,0,0,0,0,0,0,99,128], '#f240b0', '2024年天然气用量')
	]
};


// 客户用水

let userWaterXlist = [];
let userWaterValList = [];
let huanbiList = []; // 环比
let tongbiList = []; // 同比

for (let i = 1; i <= 17; i++) {
	userWaterXlist.push(`${i}号楼`);

	// 上期值（例如上月）
	let prev = (50 + Math.random() * 150).toFixed(2);

	// 当前值（在上期基础上波动）
	let current = (prev * (50 + Math.random() * 150)).toFixed(2);
	userWaterValList.push(current);

	// 环比差值（不是百分比，是实际数值）
	let huanbi = (current - prev).toFixed(2);
	huanbiList.push(huanbi);

	// 去年同期值（模拟同比基础）
	let lastYear = parseFloat((50 + Math.random() * 150).toFixed(2));
	let tongbi = (current - lastYear).toFixed(2);
	tongbiList.push(tongbi);
}
export const userWaterOption = {
	animationDuration, 
	xAxis: {
		type: 'category',
		data: userXlist,
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	grid: {
		top: 68,
		left: 60,
		right: 30,
		bottom: 30,
	},
	tooltip: {
		trigger: 'axis'
	},
	yAxis: {
		type: 'value',
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	series: [
		setData(getGasList(17), '2025年用水量 (t)', getColor('#00C0FA', '#015EEA'), '26%'),
		setZData(getGasList(17), '#ff1a06', '2024年用水量 (t)')
	],
};


export const userWaterOption2 = {
	animationDuration, 
	xAxis: {
		type: 'category',
		data: ['7-2商铺', '7-5商铺'],
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	legend: {
		type: 'scroll',
		// orient: 'vertical',
		right: 10,
		top: 10,
		symbol: 'circle', // 设置为圆形
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 10
		}
	},
	grid: {
		top: 68,
		left: 60,
		right: 30,
		bottom: 30,
	},
	tooltip: {
		trigger: 'axis'
	},
	yAxis: {
		type: 'value',
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	series: [
		setData([82, 66], '5月用水', getColor('#ff1a06', '#cb1204'), '26%'),
		setData([34, 29], '6月用水', getColor('#00C0FA', '#015EEA'), '26%'),
	],
};

// 锅炉天然气

export const chart1 =  {
	animationDuration,
	title: {
		show: false
	},
	tooltip: {
		show: true
	},
	legend: {
		// orient: 'vertical',
		// right: 80,
		top: 10,
		right: 6,
		left: 220,
		itemGap: 16,
		itemWidth: 12,
		itemHeight: 12,
		symbol: 'circle', // 设置为圆形
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 12
		}
	},
	series: [{
		name: '能源中心数量',
		type: 'pie',
		top: 40,
		radius: ['26%', '50%'],
		label:{
			show:true,
			formatter: '{b} \n({c}%)',
			fontSize: 12,
			textShadowColor: 'transparent',
			color: '#3ed3eb'
		},
		data: [{
				value: 44,
				name: '楼内公共',
				itemStyle: {
					color: '#f36565'
				},
			},
			{
				value: 36,
				name: '园区',
				itemStyle: {
					color: '#3dd3eb'
				},
			},
			{
				value: 18,
				name: '地库',
				itemStyle: {
					color: '#ff972f'
				},
			},
			{
				value: 12,
				name: '服务中心',
				itemStyle: {
					color: '#339bfd'
				},
			}
		],
		emphasis: {
			itemStyle: {
				shadowBlur: 20,
				shadowOffsetX: 10,
				// shadowColor: 'rgba(0, 0, 0, 0.5)'
			}
		}
	}]
};



// 电量分析
let hours = []
for (let i = 0; i < 24; i++) {
	hours.push(i + ':00')
}
export const chart2 = {
	animationDuration,
	title: {
		show: false
	},
	tooltip: {
		show: true
	},
	legend: {
		// orient: 'vertical',
		// right: 80,
		top: 10,
		right: 6,
		left: 220,
		itemGap: 16,
		itemWidth: 12,
		itemHeight: 12,
		symbol: 'circle', // 设置为圆形
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 12
		}
	},
	series: [{
		name: '能源中心数量',
		type: 'pie',
		top: 40,
		radius: ['26%', '50%'],
		label:{
			show:true,
			formatter: '{b} \n({c}%)',
			fontSize: 14,
			textShadowColor: 'transparent',
			color: '#3ed3eb'
		},
		data: [{
				value: 25,
				name: '楼内公共',
				itemStyle: {
					color: '#f36565'
				},
			},
			{
				value: 31,
				name: '园区',
				itemStyle: {
					color: '#3dd3eb'
				},
			},
			{
				value: 44,
				name: '地库',
				itemStyle: {
					color: '#ff972f'
				},
			}
		],
		emphasis: {
			itemStyle: {
				shadowBlur: 20,
				shadowOffsetX: 10,
				// shadowColor: 'rgba(0, 0, 0, 0.5)'
			}
		}
	}]
};


export const chart3 = {
	animationDuration, 
	title:{
		show: false
	},
	tooltip: {
		trigger: 'item',
		show: false
	},
	legend: {
		show: false
	},
	series: [{
		name: '用水分析（t）',
		type: 'pie',
		radius: ['60%', '75%'],
		avoidLabelOverlap: false,
		label: {
			show: false,
			position: 'center'
		},
		top: 25,
		left: 30,
		right: 30,
		itemStyle: {
			borderRadius: 0,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 6
		},
		// roseType: 'radius',
		emphasis: {
			label: {
				show: false,
				fontSize: 40,
				fontWeight: 'bold'
			}
		},
		labelLine: {
			show: false
		},
		data: [{
				value: 1148,
				name: '楼内公共',
				itemStyle: {
					color: '#2969ff'
				},
			},
			{
				value: 1435,
				name: '地库',
				itemStyle: {
					color:'#ffed29'
				},
			}
		]
	}]
};

export const chart4 = {
	animationDuration, 
	
	title:{
		show: false
	},
	tooltip: {
		trigger: 'item',
		show: false
	},
	legend: {
		show: false
	},
	series: [{
		name: '用水分析（t）',
		type: 'pie',
		radius: ['60%', '75%'],
		avoidLabelOverlap: false,
		label: {
			show: false,
			position: 'center'
		},
		top: 25,
		left: 30,
		right: 30,
		itemStyle: {
			borderRadius: 0,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 6
		},
		// roseType: 'radius',
		emphasis: {
			label: {
				show: false,
				fontSize: 40,
				fontWeight: 'bold'
			}
		},
		labelLine: {
			show: false
		},
		data: [{
				value: 748,
				name: '楼内公共',
				itemStyle: {
					color:'#2969ff'
				},
			},
			{
				value: 635,
				name: '地库',
				itemStyle: {
					color:'#ffed29'
				},
			}
		]
	}]
};

export const chart5 = {
	animationDuration, 
	
	title:{
		show: false
	},
	tooltip: {
		trigger: 'item',
		show: false
	},
	legend: {
		show: false
	},
	series: [{
		name: '用水分析（t）',
		type: 'pie',
		radius: ['60%', '75%'],
		avoidLabelOverlap: false,
		label: {
			show: false,
			position: 'center'
		},
		top: 25,
		left: 30,
		right: 30,
		itemStyle: {
			borderRadius: 0,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 6
		},
		// roseType: 'radius',
		emphasis: {
			label: {
				show: false,
				fontSize: 40,
				fontWeight: 'bold'
			}
		},
		labelLine: {
			show: false
		},
		data: [{
				value: 128,
				name: '楼内公共',
				itemStyle: {
					color:'#2969ff'
				},
			},
			{
				value: 335,
				name: '地库',
				itemStyle: {
					color:'#ffed29'
				},
			}
		]
	}]
};